import { Typography } from '@yanolja-rnd/ya-com-core'
import { styled } from '~/app/components'

const Container = styled.div`
  display: flex;
  gap: 0.4rem;
  flex-wrap: wrap;
`
const BenefitBadge = styled.div`
  padding: 0.3rem 0.6rem 0.2rem;
  border: 0.1rem solid ${({ theme }) => theme.color.gray100};
  border-radius: 0.6rem;
  color: ${({ theme }) => theme.color.gray600};
  ${Typography('caption').bold};
  word-break: keep-all;
`

/**
 * Pre-Order(장바구니, 주문서, 쿠폰 선택 모달)에서 사용되는 RatePlan 옵션 안내
 * - 뱃지 스타일
 */
const RatePlanBenefits = ({ ratePlanBenefits }: { ratePlanBenefits: string[] }) => {
  return (
    <Container>
      {ratePlanBenefits.map((benefit, index) => (
        <BenefitBadge key={index}>{benefit}</BenefitBadge>
      ))}
    </Container>
  )
}

export default RatePlanBenefits
